@let scaleName = scaleRatio();
<div cdkMenuBar>
    <button id="btn-scale-drop-down" class="btn-flat" cdkMenuItem [cdkMenuTriggerFor]="autoMeasureMenu">
        Scale:
        <span
            class="scale-name"
            [popover]="aiScaledDisclaimer"
            triggers=""
            #pop="bs-popover"
            placement="bottom"
            container="body"
            [outsideClick]="true"
            >{{ isScaled() ? (scaleName ?? 'Manual') : 'Not Scaled' }}</span
        >
        <i class="fa-light fa-chevron-down"></i>
    </button>
</div>

<ng-template #aiScaledDisclaimer>
    <div class="disclaimer-container">
        <div class="disclaimer-header">
            <span class="icon"><i class="fa-light fa-bullseye-pointer"></i></span> <span class="text">Auto-detected scale</span>
        </div>
        <p class="disclaimer-text">Please verify the scale for accuracy when measuring</p>
    </div>
</ng-template>

<ng-template #autoMeasureMenu>
    <div class="dropdown-menu-container mt-1" cdkMenu>
        <div class="scale-selector">
            @if (isAIScaled() || hasAnalysedScales()) {
                <div class="status-banner">
                    <span class="icon"><i class="fa-light fa-bullseye-pointer"></i></span>
                    <span class="text">Auto-detected scale</span>
                    <span class="subtext"><i class="fa-light fa-info-circle"></i>Please verify when measuring</span>
                </div>
            }

            @if (canSetScaleRatio()) {
                <div class="scale-table">
                    <div class="scale-header">
                        <div>Architectural</div>
                        <div>Ratio / Metric</div>
                    </div>
                    <div class="scale-rows">
                        <div class="scale-column">
                            <a
                                id="arch-scale-{{ arch.name }}"
                                class="btn-flat scale-row"
                                *ngFor="let arch of architecturalScales"
                                [class.selected]="arch.name === scaleName"
                                (click)="selectScale(arch, ScaleType.this)"
                                cdkMenuItem>
                                {{ arch.name }}
                                <button
                                    cdkMenuItem
                                    [cdkMenuTriggerFor]="moreActions"
                                    class="scale-row__more"
                                    id="overflow-menu-{{ arch.name }}"
                                    (click)="$event.stopPropagation()">
                                    <i class="icon-ic-ellipse-s1"></i>
                                </button>
                                <ng-template #moreActions>
                                    <div class="dropdown-menu-container ml-1" cdkMenu>
                                        <a id="apply-to-this-plan" cdkMenuItem class="btn-flat" (click)="selectScale(arch, ScaleType.this)">
                                            <i class="fa-light fa-file mr-1"></i> Apply to this plan
                                        </a>
                                        <a id="apply-to-all-plan" cdkMenuItem class="btn-flat" (click)="selectScale(arch, ScaleType.all)">
                                            <i class="fa-light fa-files mr-1"></i> Apply to all plans
                                        </a>
                                    </div>
                                </ng-template>

                                <span *ngIf="arch.name === scaleName" class="checkmark"><i class="fa-light fa-check"></i></span>
                            </a>
                        </div>
                        <div class="scale-column">
                            <a
                                id="metric-scale-{{ metric.name }}"
                                class="btn-flat scale-row"
                                *ngFor="let metric of metricScales"
                                [class.selected]="metric.name === scaleName"
                                (click)="selectScale(metric, ScaleType.this)">
                                <span>{{ metric.name }}</span>
                                <button
                                    cdkMenuItem
                                    [cdkMenuTriggerFor]="moreActions"
                                    class="scale-row__more"
                                    id="overflow-menu-{{ metric.name }}"
                                    (click)="$event.stopPropagation()">
                                    <i class="icon-ic-ellipse-s1"></i>
                                </button>
                                <ng-template #moreActions>
                                    <div class="dropdown-menu-container ml-1" cdkMenu>
                                        <a
                                            id="apply-to-this-plan"
                                            cdkMenuItem
                                            class="btn-flat"
                                            (click)="selectScale(metric, ScaleType.this)">
                                            <i class="fa-light fa-file mr-1"></i> Apply to this plan
                                        </a>
                                        <a id="apply-to-all-plan" cdkMenuItem class="btn-flat" (click)="selectScale(metric, ScaleType.all)">
                                            <i class="fa-light fa-files mr-1"></i> Apply to all plans
                                        </a>
                                    </div>
                                </ng-template>
                                <span *ngIf="metric.name === scaleName" class="checkmark"><i class="fa-light fa-check"></i></span>
                            </a>
                        </div>
                    </div>
                </div>
            }

            <div class="actions">
                <div class="actions-container">
                    <button id="scale-manually" class="btn-bx-secondary-stroked" (click)="scaleManually()">Scale manually</button>

                    @let hasAddon = takeOffAddOnService.hasAddOn();
                    @if (hasAddon) {
                        <button id="auto-scale" class="btn-bx-secondary-stroked btn-bx-pro" (click)="autoDetectScale()">
                            <img class="detailed-logo" src="../../../../../assets/images/add-ons/blu-logo.svg" /> Auto detect scale
                        </button>
                    }
                </div>

                @if (isAutoMeasureEnabled && takeOffAddOnService.canTakeOffAddonBeSubscribed() && !hasAddon) {
                    <button
                        id="scale-via-takeoff-assistant"
                        class="btn-bx-secondary-stroked btn-bx-pro takeoff-assistant"
                        (click)="getScaleDetection()">
                        <img class="detailed-logo" src="../../../../../assets/images/add-ons/blu-logo.svg" />
                        Takeoff Assistant
                    </button>
                }
            </div>
        </div>
    </div>
</ng-template>
